import { createContext, useContext } from 'react';

const AdminPermissionContext = createContext<((permission: string | string[]) => boolean) | null>(null);
export const AdminPermissionProvider = AdminPermissionContext.Provider;
export const useAdminPermission = () => useContext(AdminPermissionContext);
